import { ReactElement } from 'react';
import { LayoutType } from '@sandtech-hub-monorepo/ui-kit';

export enum RouteAccess {
  PRIVATE = 'private',
  PUBLIC = 'public',
}

export enum ProfileTabSections {
  Personal = 'personal',
  Education = 'education',
  Work = 'work',
  Demographic = 'demographic',
}

export enum SettingsTabsList {
  Payments = 'payments',
  PaymentsFAQ = 'payments-faq',
  HubAttendance = 'hub-attendance',
  Password = 'password',
}

export const AppRoutesPaths = {
  Home: '/',
  Profile: '/profile',
  ProfilePersonal: '/profile/' + ProfileTabSections.Personal,
  ProfileEducation: '/profile/' + ProfileTabSections.Education,
  ProfileWork: '/profile/' + ProfileTabSections.Work,
  ProfileDemographic: '/profile/' + ProfileTabSections.Demographic,
  Community: '/community',
  Learning: '/learning',
  PublicProfile: '/profile/:userId',
  Programs: '/programs',
  Program: '/program/:programId',
  Support: '/support',
  Settings: '/settings',
  Payments: '/settings/' + SettingsTabsList.Payments,
  PaymentFAQS: '/settings/' + SettingsTabsList.PaymentsFAQ,
  HubAttendance: '/settings/' + SettingsTabsList.HubAttendance,
  Password: '/settings/' + SettingsTabsList.Password,

  //   Auth Routes
  Login: '/login',
  Logout: '/logout',
  SignUp: '/sign-up',
  ConfirmSignUp: '/sign-up-confirmation',
  ResetPassword: '/reset-password',
  CreatePassword: '/create-password',
  OauthToken: '/oauth/token',

  // Misc
  PublicBadgeVerify: '/badges/verify/:verificationCode',
  PublicCertificateVerify: '/certificates/verify/:verificationCode',
  PublicSupport: '/guest-support',
  PublicPaymentFAQs: `/${SettingsTabsList.PaymentsFAQ}`,
  NotFound: '*',
};

export interface IRouteDefinition {
  path: string;
  name?: string;
  element: ReactElement;
  layout: LayoutType;
}
